module.exports = __webpack_public_path__ + "img/Certificate.1ddabaa1.jpg";